import React from 'react'
import {LinkStyles, Text} from '@miro-site/core'
import styled, {DefaultTheme} from 'styled-components'
import {ContentOptions} from './types'

export const ITEM_CONTENT_SIZES: Record<string, keyof DefaultTheme['typography']['paragraphs']> = {
  small: 'p1',
  large: 'p0',
  tiny: 'p2',
}

const ITEM_CONTENT_COLORS: Record<string, keyof DefaultTheme['colors']> = {
  dark: 'primaryIndigo',
  grey: 'greyish',
  white: 'primaryWhite',
}

const WEIGHT = {
  medium: undefined,
  bold: 700,
}
type ContentProps = ContentOptions & {
  textProps?: React.ComponentProps<typeof Text>
  colorTransparency?: number | string | null
}

const Content = ({
  html,
  size = 'small',
  color = 'grey',
  textProps = {},
  colorTransparency,
  weight = 'medium',
}: ContentProps): React.ReactElement => {
  textProps.$styles = {
    fontWeight: WEIGHT[weight],
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    ...(textProps.$styles || {}),
  }

  const props = {
    ...textProps,
    $variant: ITEM_CONTENT_SIZES[size],
    $color: ITEM_CONTENT_COLORS[color],
    $transparency: colorTransparency,
  }

  if (typeof html === 'string') {
    return <TextWithInlineHtml dangerouslySetInnerHTML={{__html: html}} {...props} />
  }

  return <TextWithInlineHtml {...props}>{html}</TextWithInlineHtml>
}

const TextWithInlineHtml = styled(Text)`
  a {
    ${props =>
      props.theme.normalizeStyles({
        ...LinkStyles.resetStyles,
        ...LinkStyles.variants.richText,
        ...LinkStyles.colors.default,
      })}
  }
`

export default Content
